<template>
  <div class="map-1-wrapper">
    <div class="map-1 w-100">
      <l-map
          ref="map"
          :zoom="zoom"
          :center="location">
        <l-tile-layer
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            layer-type="base"
            name="OpenStreetMap"
        ></l-tile-layer>

        <l-marker :lat-lng="location"></l-marker>
      </l-map>

    </div>
  </div>
</template>

<script>
import "leaflet/dist/leaflet.css";
import {LMap, LTileLayer, LMarker} from "@vue-leaflet/vue-leaflet";


export default {
  name: "Map1",
  components: {
    LMap,
    LTileLayer,
    LMarker,
  },
  props: {
    location: {},
    zoom: {
      default: 18
    }
  }
}
</script>

<style scoped>
.map-1 {
  height: 380px;
}
</style>